<template>
  <div class="card mb-4" @click="onClickOption">
    <div class="text-center">
      <img class="card-img-top" :src="option.image | image('190x')">
    </div>
    <div class="card-body">
      <h5 class="card-title text-center">
        {{ option.name }}
      </h5>
      <p class="card-text" v-html="option.description" />
      <div v-if="price > 0" class="price-box">
        <div class="d-flex flex-wrap align-items-center justify-content-center">
          <b-spinner v-if="loading" variant="primary" />
          <span v-else>
            <span v-if="option.discount > 0" class="badge badge-danger mr-3">-{{ option.discount }}%</span>
            <div class="d-flex flex-column">
              <span class="price-discount">{{ price | currency }}</span>
              <span v-if="option.discount > 0" class="price-old">{{ oldPrice | currency }}</span>
            </div>
          </span>
        </div>
      </div>
    </div>
    <div class="card-footer bg-primary" :class="{ 'not-selected': !option.selected }">
      <span v-if="option.selected">Ausgewählt</span>
      <span v-else>Auswählen</span>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    option: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: null
    }
  },
  data: () => ({
    backsideStatus: false
  }),
  computed: {
    ...mapGetters({
      currentStep: 'configurator/currentStep',
      getTotalPrice: 'configurator/totalPrice',
      steps: 'configurator/steps'
    }),
    loading () {
      return this.priceAll && this.totalPrice.loading
    },
    priceAll () {
      return this.currentStep.price_all || false
    },
    totalPrice () {
      return this.getTotalPrice(this.option)
    },
    price () {
      if (!this.option) {
        return null
      }
      if (this.priceAll) {
        return this.totalPrice.discounted || this.totalPrice.total
      }

      if (this.option.price) {
        if (!isNaN) {
          return this.option.price.discounted
        } else {
          if (this.option.discount > 0) {
            const discount = Number.parseFloat(this.option.discount) / 100 * this.option.price.self
            let totalDiscount = 0
            totalDiscount = this.option.price.self - discount
            return totalDiscount
          } else {
            return this.option.price.self
          }
        }
      }
      return 0
    },
    /* eslint-disable */
    optionDiscount () {
      const dimension = this.steps.find(s => s.type === 'dimension')
      if (dimension.width.value === 300 && dimension.height.value === 120) {
        return 0
      }
    },
    oldPrice () {
      if (!this.option) {
        return null
      }
      if (this.priceAll) {
        return this.totalPrice.old_price
      }
      if (this.option.price) {
        return this.option.price.self
      }
      return 0
    },
    /* eslint-disable */
    currentOptionId () {
      if (this.currentStep.name === 'Form') {
        const optionId = this.currentStep.options.find(o => o.selected).id
        return optionId
      }
    }
  },
  created () {
    if (this.priceAll) {
      this.calculatePriceAll({ option: this.option })
    }
  },
  methods: {
    ...mapActions({
      toggleOption: 'configurator/toggleOption',
      selectOption: 'configurator/selectOption',
      calculatePriceAll: 'configurator/calculatePriceAll',
      setBacksideOption: 'configurator/setBacksideOption'
    }),
    onClickOption () {
      if (this.option.disabled) {
        return
      }
      if (this.option.type === 'check') {
        this.toggleOption(this.option)
      } else {
        this.selectOption(this.option)
      }
    }
  }
}
</script>
